export const transFields = [
    'TRANS_ID',
    'TOTAL_ITEMS_BASE_PRICE',
    'TOTAL_ITEMS_APPLIED_PRICE',
    'TOTAL_ITEMS_DISCOUNT',
    'TOTAL_SHIPPING_APPLIED_PRICE',
    'TOTAL_GIFTWRAP_APPLIED_PRICE',
    'TOTAL_APPLIED_TAX',
    'TOTAL_COST',
    'TOTAL_RETAIL_DELIVERY_FEE',
    'creditCardPaymentAmount',
    'giftCardPaymentAmount',
    'getDonation',
    'getDonationsDerivedSubtotal',
    'providerPaymentAmount',
    'totals',
    'payments',
    'paymentInstallments',
    'loyaltyPoints',
    'checkHasOrderItems',
    'isPayPal',
    'isDiscounted',
    'canAfterPay',
    'formatted.proItemDiscount',
    'formatted.TOTAL_ITEMS_BASE_PRICE',
    'formatted.TOTAL_ITEMS_APPLIED_PRICE',
    'formatted.TOTAL_ITEMS_DISCOUNT',
    'formatted.TOTAL_SHIPPING_APPLIED_PRICE',
    'formatted.TOTAL_GIFTWRAP_APPLIED_PRICE',
    'formatted.TOTAL_APPLIED_TAX',
    'formatted.TOTAL_COST',
    'formatted.creditCardPaymentAmount',
    'formatted.giftCardPaymentAmount',
    'formatted.providerPaymentAmount',
    'formattedTaxRate',
    'formattedTotalTax',
    'total_applied_vat',
    'retailDeliveryFeeJurisdiction',
    'totalItemsDiscount',
    'formattedTotalItemsDiscount'
];
